import React, { useMemo, useState, createContext } from "react";
import { getAllKeys } from './utils/storage';
import detectBrowserLanguage from 'detect-browser-language';

export const Contexts = createContext(null);

export const ContextProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [deals, setDeals] = useState([]);
    const [stores, setStores] = useState([]);
    const [searchString, setSearchString] = useState('');
    const [page, setPage] = useState(1);
    const [favoriteOpen, setFavoriteOpen] = useState(false);
    const [favorites, setFavorites] = useState(() => getAllKeys());
    const [userLanguage, setUserLanguage] = useState(() => {
        switch (detectBrowserLanguage()) {
            case 'zh-cn':
                return "simplified";
            case 'zh-tw':
                return "traditional";
            default:
                return "traditional";
        }
    });
    const [dialog, setDialog] = React.useState({ open: false, content: null });
    const [category, setCategory] = React.useState('42');
    const [dstore, setDstore] = React.useState('Amazon');
    const [cookie, setCookie] = React.useState(true);

    const contexts = useMemo(() => {
        return { isLoading, setIsLoading, deals, setDeals, stores, setStores, searchString, setSearchString, page, setPage, favoriteOpen, setFavoriteOpen, favorites, setFavorites, userLanguage, setUserLanguage, dialog, setDialog, category, setCategory, dstore, setDstore, cookie, setCookie };
    }, [isLoading, setIsLoading, deals, setDeals, stores, setStores, searchString, setSearchString, page, setPage, favoriteOpen, setFavoriteOpen, favorites, setFavorites, userLanguage, setUserLanguage, dialog, setDialog, category, setCategory, dstore, setDstore, cookie, setCookie]);

    return <Contexts.Provider value={contexts}>{children}</Contexts.Provider>;
};
